export default {
  path: '/students',
  component: resolve => require(['@/components/common/ViewTemplate'], resolve),
  children: [
    {
      path: '',
      component: resolve => require(['@/components/student/StudentManager'], resolve),
    },
    {
      path: ':student_id/student-detail',
      name: 'studentDetail',
      component: resolve => require(['@/components/student/StudentDetail'], resolve),
    },
    {
      path: ':student_id/u-student-detail',
      name: 'uStudentDetail',
      component: resolve => require(['@/components/student/UStudentDetail'], resolve),
    },
    {
      path: ':student_id/change-student-password',
      name: 'ChangeStudentPassword',
      component: resolve => require(['@/components/student/ChangeStudentPassword'], resolve),
    },
    {
      path: ':student_id/card-list',
      name: 'CardList',
      component: resolve => require(['@/components/student/CardList'], resolve),
    },
    {
      path: ':student_id/course-detail',
      name: 'CourseDetail',
      component: resolve => require(['@/components/student/CourseDetail'], resolve),
    },
    {
      path: ':student_id/confirm-card',
      name: 'ConfirmCard',
      component: resolve => require(['@/components/student/ConfirmCard'], resolve),
    },
    {
      path: ':student_id/open-card-success',
      name: 'OpenCardSuccess',
      component: resolve => require(['@/components/student/OpenCardSuccess'], resolve),
    },
    {
      path: ':student_id/student-report',
      component: resolve => require(['@/components/student/StudentReport'], resolve),
    },
    {
      path: 'duty-report',
      component: resolve => require(['@/components/student/DutyReport'], resolve),
    },
    {
      path: ':student_id/book-version',
      component: resolve => require(['@/components/student/BookVersion'], resolve),
    },
    {
      path: 'recruit-student-list',
      component: resolve => require(['@/components/student/RecruitStudentList'], resolve),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/modules/student/index.js